import { render, staticRenderFns } from "./EditBuildingMultibuildingProject.vue?vue&type=template&id=00a9718a"
import script from "./EditBuildingMultibuildingProject.vue?vue&type=script&lang=js"
export * from "./EditBuildingMultibuildingProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports